<template>
    <div class="row">

        <div
            class="col-xs-12 col-sm-12"
            v-bind:class="{ 'col-sm-12': report.newClientsPercentage === 100 }"
        >
            <div class="box chart-holder">
                <h2>{{ t("orderReports-charts-retention_curve") }}</h2>
                <area-chart
                    :chart-data="ordersPerCustomerChartData"
                    :options="distributionChartOptions"
                    :height="218"
                />
            </div>
        </div>
    </div>
</template>
<script>
import $store from "./../order-report.store.js";
export default {
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
    computed: {
        report() {
            return this.$store.state.ordersReport.report;
        },
        distributionChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    callbacks: {
                        label: (tooltipItems) => {
                            let percentage = parseFloat(tooltipItems.yLabel);
                            let clients = Math.round(
                                (percentage / 100) *
                                    $store.state.ordersReport.report.counters
                                        .clients,
                            );
                            return this.t(
                                "orderReports-tooltips-clients_percentage",
                                [percentage, clients],
                            );
                        },
                    },
                },
                scales: {
                    yAxes: [
                        {
                            type: "linear",
                            position: "left",
                            scaleLabel: {
                                display: true,
                                labelString: this.t(
                                    "orderReports-chart_axes-client_percentage",
                                ),
                            },
                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 6,
                            },
                        },
                    ],
                    xAxes: [
                        {
                            scaleLabel: {
                                display: true,
                                labelString: this.t(
                                    "orderReports-chart_axes-orders_in_period",
                                ),
                            },
                        },
                    ],
                },
            };
        },
        ordersPerCustomerChartData() {
            return {
                labels: this.report.ordersPerClient.labels,
                datasets: [
                    {
                        label: this.t(
                            "orderReports-chart_axes-client_percentage",
                        ),
                        borderColor: "var(--primary)",
                        borderWidth: 2,
                        pointRadius: 3,
                        pointBackgroundColor: "#EEE",
                        backgroundColor: "rgba(167,204,192,0.7)",
                        data: this.report.ordersPerClient.clients,
                    },
                ],
            };
        },
    },
};
</script>
